export interface ExportDataRespons {
  reportType: ReportType;
  isComparison: boolean;
  users: number[];
}
export enum ReportType {
  PDF, CSV
}